import { useMutation } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import { getLocalStorage } from '@/Utils/CommonUtils';

interface SendPaymentSuccessWhatsappParams {
  order_id: string;
  plan_type?: 'personal' | 'group' | 'webinar';
  duration_months?: number;
  amount?: number;
  currency?: string;
}

interface SendPaymentSuccessWhatsappResponse {
  success: boolean;
  message?: string;
}

export default function useSendRenewalPaymentSuccessWhatsapp(
  handleOnSuccess?: (data: SendPaymentSuccessWhatsappResponse) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<
    SendPaymentSuccessWhatsappResponse,
    Error,
    SendPaymentSuccessWhatsappParams
  >(
    async params => {
      const token = await getLocalStorage('access_token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const response = await ChessRestClient.post<SendPaymentSuccessWhatsappResponse>(
        'subscription/v1/send-renewal-payment-success-whatsapp/',
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}

